// extracted by mini-css-extract-plugin
module.exports = {"header-more":"_5orShcopVthfRRaN752e"};